var AboutHero = (function($) {
  function init() {
    var $trigger = $(".link--expandable");
    if (!$trigger.length) return;

    $trigger.on("click", function(e) {
      e.preventDefault();

      var $btn = $(this);
      var $info = $btn.closest(".about-hero-info");
      var $hidden = $info.find(".about-hero-info--hidden");

      var isExpanded = $info.hasClass("about-hero-info--expanded");

      $info.toggleClass("about-hero-info--expanded");
      $btn.attr("aria-expanded", String(!isExpanded));

      $btn.text(isExpanded ? "Read more" : "Read less");

      // Al expandir, hacemos scroll para que se note (opcional pero recomendable)
      if (!isExpanded) {
        // espera un pelín a que empiece la animación
        // setTimeout(function() {
        //   $("html, body").animate(
        //     { scrollTop: $hidden.offset().top - 140 }, // 140 ~ header + aire
        //     450
        //   );
        // }, 120);
      }
    });
  }

  function initAnnualReports() {
    $("#link-annual-reports").click(function(e) {
      e.preventDefault();
      $(".about-reports-list").toggleClass("about-reports-list--expanded");
    });
    $("#link-annual-reports-mobile").click(function(e) {
      e.preventDefault();
      $(".about-reports-list-mobile").toggleClass(
        "about-reports-list--expanded"
      );
    });
  }

  initAnnualReports();

  return { init: init };
})(jQuery);

jQuery(document).ready(AboutHero.init);
